import React, { useState } from 'react';
import { getPaginationFilter, paginationKeys } from 'app/shared/util/pagination.constants';
import { ButtonGroup, Col, Row } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { isEqual } from 'lodash';
import {
  ChamberMemberOverviewFilterModel,
  ChamberMemberOverviewRow,
  initialChamberMemberOverviewFilterModel,
} from 'app/edozvola/chamber-member-overview/model/chamber-member-overview.model';
import { ChamberMemberFilterModal } from 'app/edozvola/chamber-member-overview/chamber-member-filter-modal';
import {
  fetchChamberMemberOverviewQuery
} from 'app/edozvola/chamber-member-overview/service/chamber-member-overview.queries';

const ChamberMemberOverview = () => {
  const [chamberMemberFilter, setChamberMemberFilter] = useState<ChamberMemberOverviewFilterModel>(
    getPaginationFilter(paginationKeys.CHAMBER_MEMBER_OVERVIEW) || initialChamberMemberOverviewFilterModel,
  );
  const [chamberMemberFilterShown, setChamberMemberFilterShown] = useState<boolean>(false);

  const renderTableRow = (value: ChamberMemberOverviewRow) => {
    return (
      <tr key={value.idChamberMember}>
        <td>{value.authorizationNumber}</td>
        <td>{value.chamber}</td>
        <td>{value.firstName + ' ' + value.lastName}</td>
        <td>{value.title}</td>
        <td>{value.companyName}</td>
        <td>{value.companyAddress}</td>
      </tr>
    );
  };

  const filterActive = () => {
    return !isEqual(chamberMemberFilter, initialChamberMemberOverviewFilterModel);
  };

  const resetFilter = () => {
    setChamberMemberFilter(initialChamberMemberOverviewFilterModel);
    localStorage.removeItem(`${paginationKeys.CHAMBER_MEMBER_OVERVIEW}-filter-form`);
  };

  return (
    <div className={'container-fluid view-container'}>
      <h3>Projektanti</h3>
      <Row className={'mt-4'}>
        <Col>
          {!filterActive() && (
            <ButtonGroup>
              <Button
                className={'btn-full-width'}
                prependIcon={'filter'}
                size={'lg'}
                color={'primary'}
                label="Filteri"
                onClick={e => {
                  setChamberMemberFilterShown(true);
                  e.currentTarget.blur();
                }}
              ></Button>
            </ButtonGroup>
          )}
          {filterActive() && (
            <div className={'custom-btn-group'}>
              <Button
                className={'btn-group-first-button btn-primary-width'}
                prependIcon={'filter'}
                color={'info'}
                size={'lg'}
                label="Filteri"
                onClick={e => {
                  setChamberMemberFilterShown(true);
                  e.currentTarget.blur();
                }}
              ></Button>
              <TooltipWrapper message={'Poništi filtere'}>
                <Button
                  className={'btn-group-last-button btn-secondary-width'}
                  prependIcon={'xmark'}
                  color={'info'}
                  size={'lg'}
                  label=" "
                  onClick={e => {
                    resetFilter();
                    e.currentTarget.blur();
                  }}
                ></Button>
              </TooltipWrapper>
            </div>
          )}
        </Col>
      </Row>
      <Row className={'mt-4'}>
        <Col>
          <ViewTable
            renderTableRow={renderTableRow}
            fetchDataQuery={fetchChamberMemberOverviewQuery}
            fetchDataProps={chamberMemberFilter}
            noDataMessage={'Nema projektanata koji odgovaraju unesenim parametrima.'}
            localStorageKey={paginationKeys.CHAMBER_MEMBER_OVERVIEW}
            initialPaginationColumn={'authorizationNumber'}
          >
            <ViewTableHeaderColumn renderSort={false} columnLabels={['Broj ovlaštenja']} />
            <ViewTableHeaderColumn renderSort={false} columnLabels={['Komora']} />
            <ViewTableHeaderColumn renderSort={false} columnLabels={['Ime i prezime']} />
            <ViewTableHeaderColumn renderSort={false} columnLabels={['Zvanje']} />
            <ViewTableHeaderColumn renderSort={false} columnLabels={['Tvrtka']} />
            <ViewTableHeaderColumn renderSort={false} columnLabels={['Adresa tvrtke']} />
          </ViewTable>
        </Col>
      </Row>
      <ChamberMemberFilterModal
        filterForm={chamberMemberFilter}
        setFilterForm={setChamberMemberFilter}
        modal={chamberMemberFilterShown}
        closeModal={setChamberMemberFilterShown}
      />
    </div>
  );
}

export default ChamberMemberOverview;
